import { Gender, InvoicePreference } from './constants';

export interface UpdateProfilePayload {
  BirthDateYear: number;
  BirthDateMonth: number; // starts at 1
  BirthDateDay: number;
  Language: string;
  Gender: Gender;
  PreferredPharmacyId: string;
  Lastname: string;
  Firstname: string;
  PostalCode: string;
  Phones: {
    CellPhone: string;
    OtherPhone: string;
  };
  EReceiptPreference: InvoicePreference;
  SmsConsent: boolean | null;
  ProfilingConsent: boolean | null;
}

/**
 * Create an UpdateProfilePayload object from the data received from a GetProfile api call
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createUpdateProfilePayload = (getProfileData: any): UpdateProfilePayload => {
  return {
    BirthDateYear: getProfileData.BirthDateYear,
    BirthDateMonth: getProfileData.BirthDateMonth,
    BirthDateDay: getProfileData.BirthDateDay,
    Language: getProfileData.Language,
    Gender: getProfileData.Gender,
    PreferredPharmacyId: getProfileData.PreferredPharmacyId,
    Lastname: getProfileData.Lastname,
    Firstname: getProfileData.Firstname,
    PostalCode: getProfileData.PostalCode,
    Phones: {
      CellPhone: getProfileData.Phones.CellPhone,
      OtherPhone: getProfileData.Phones.OtherPhone,
    },
    EReceiptPreference: getProfileData.EReceiptPreference,
    SmsConsent: getProfileData.SmsConsent,
    ProfilingConsent: getProfileData.ProfilingConsent,
  };
};
